import React from 'react';
import { FrameBroker, WsClientBroker } from '@beefco/bus';
import { GlobalBridgeContext } from "../context";
import { Bridge } from "../Bridge";
export var withGlobalBridge = function withGlobalBridge(commandBusFactory) {
  return function (WrappedComponent) {
    var frameBroker = new FrameBroker();
    var wsClientBroker = new WsClientBroker();
    var globalBridge = new Bridge(frameBroker, wsClientBroker, commandBusFactory(wsClientBroker, frameBroker));
    return function (props) {
      return /*#__PURE__*/React.createElement(GlobalBridgeContext.Provider, {
        value: globalBridge
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    };
  };
};